// Globals
import React, { SyntheticEvent } from 'react';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { PopConfirm } from '@/ui';
import { useAppState } from '@/store';

// Store
import { selectShippingPricesIsLoading } from '../../feature';

type TDisableTaxesSwitch = {
  taxExemptRegion: boolean;
  onChange: (values: { taxExemptRegion: boolean }) => void;
};

const DisableTaxesSwitch = ({ onChange, taxExemptRegion }: TDisableTaxesSwitch) => {
  const { t } = useTranslation(['common']);
  const isLoading = useAppState(selectShippingPricesIsLoading);

  const handleConfirmChanges = () => {
    onChange?.({ taxExemptRegion: !taxExemptRegion });
  };

  const handleStopPropagation = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <div onClick={handleStopPropagation} onKeyDown={handleStopPropagation}>
      <PopConfirm
        title={t(taxExemptRegion ? 'modal_calculate_taxes_title' : 'modal_skip_taxes_title')}
        onConfirm={handleConfirmChanges}
      >
        <Switch
          checked={taxExemptRegion}
          checkedChildren={t('modal_taxes_ignore_title')}
          unCheckedChildren={t('modal_taxes_calculate_title')}
          loading={isLoading}
        />
      </PopConfirm>
    </div>
  );
};

export default DisableTaxesSwitch;
